export const SET_REPORTS = 'SET_REPORTS';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const SET_REPORTS_RANGE_TO_SHOW = 'SET_REPORTS_RANGE_TO_SHOW';
export const OPEN_NEW_REPORT_MODAL = 'OPEN_NEW_REPORT_MODAL';
export const CLOSE_NEW_REPORT_MODAL = 'CLOSE_NEW_REPORT_MODAL';
export const SET_REPORTS_FILTERED_BY_TYPE = 'SET_REPORTS_FILTERED_BY_TYPE';
export const SET_REPORTS_FILTERED_BY_RANGE = 'SET_REPORTS_FILTERED_BY_RANGE';
export const DELETE_REPORT = 'DELETE_REPORT';
export const SET_FILTER_REPORT = 'SET_FILTER_REPORT';
export const RESET_FILTER_REPORT = 'RESET_FILTER_REPORT';
export const OPEN_LOAD_SPINNER = 'OPEN_LOAD_SPINNER';
export const CLOSE_LOAD_SPINNER = 'CLOSE_LOAD_SPINNER';
export const SHOW_ON_SKELETON = 'SHOW_ON_SKELETON_REPORT';
export const HIDE_ON_SKELETON = 'HIDE_ON_SKELETON_REPORT';
